import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CategoryData, getExportingOptions } from '../utils/jsonDataProcessing';

interface CategoryDonutChartProps {
  categoryData: CategoryData;
}

const CategoryDonutChart: React.FC<CategoryDonutChartProps> = ({ categoryData }) => {
  const pieChartData = Object.entries(categoryData.categoryCounts).map(([name, count]) => ({
    name,
    y: count
  }));

  const options = {
    chart: {
      type: 'pie',
      height: '400px'
    },
    title: {
      text: ''
    },
    plotOptions: {
      pie: {
        innerSize: '60%',
        depth: 45,
        dataLabels: {
          enabled: true
        }
      }
    },
    series: [{
      name: 'Keywords',
      data: pieChartData
    }],
    ...getExportingOptions('Category Donut')
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CategoryDonutChart;
